// import React, { useEffect, useRef, useState } from 'react';
// import CloseIcon from '@mui/icons-material/Close';
// import SearchIcon from '@mui/icons-material/Search';
// import api from '../../api/api';
// import { useLocation } from 'react-router-dom';
// import { set } from 'date-fns';
// import { DateTime } from 'luxon';

// import 'react-time-picker/dist/TimePicker.css'
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { TimePicker, Stack } from 'rsuite';
// import 'rsuite/dist/rsuite.min.css';
//   import { parse, format, isValid } from 'date-fns';
// import dayjs from 'dayjs';
// import { CircularProgress } from '@mui/material';
// const EmpModal = ({ setEmpModal,previousdate, group_by, setAlertMessage,fetchdata, setSeverity, setOpen }) => {
//   const today = new Date().toISOString().split("T")[0];
//   const [suggestions, setSuggestions] = useState([]);
//   const [costs, setCosts] = useState([]);
//   const [errors, setErrors] = useState({});

//   const [employeeSuggestions, setEmployeeSuggestions] = useState([]);
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [showCostSuggestions, setShowCostSuggestions] = useState(false);
//   const [showEmpSuggestions, setShowEmpSuggestions] = useState(false);
//   const [jobCode, setJobCode] = useState('');
//   const [costCode, setCostCode] = useState('');
//   const [employeeId, setEmployeeId] = useState('');
//   const [selectedJobName, setSelectedJobName] = useState('');
//   const [selectedCostDescription, setSelectedCostDescription] = useState('');
//   const [clockInDate, setClockInDate] = useState(today);
//   const [clockInTime, setClockInTime] = useState('');
//   const [clockOutTime, setClockOutTime] = useState('');
//   const [breakTime, setBreakTime] = useState(0);
//   const [selectedempobj,setselectedempobj]=useState({})
//   const [perDiem, setPerDiem] = useState('');
//   const location = useLocation();
// const [loadingEmployees, setLoadingEmployees] = useState(false);
// const [loadingJobs, setLoadingJobs] = useState(false);
// const [loadingCostCodes, setLoadingCostCodes] = useState(false);
// const [empFocusedIndex, setEmpFocusedIndex] = useState(-1);
// const [jobFocusedIndex, setJobFocusedIndex] = useState(-1);
// const [costFocusedIndex, setCostFocusedIndex] = useState(-1);
//   const [jobNotFound, setJobNotFound] = useState(false);
// const [costNotFound, setCostNotFound] = useState(false);
//   const queryParams = new URLSearchParams(location.search);
//   const date = queryParams.get("date");
// const companyname=queryParams.get('company')
//   const [selectdate, setSelectdate] = useState(() => {
//     if (previousdate) {
//       return dayjs(previousdate).toDate(); // ✅ prefer previousdate if provided
//     } else if (date) {
//       return dayjs(date, "YYYY-MM-DD").toDate(); // ✅ query param date
//     } else {
//       return dayjs().toDate(); // ✅ fallback current date
//     }
//   });

//   const [classification, setClassification] = useState('');
//   const [companyTabs, setCompanyTabs] = useState([]); // Replaces 'Tabs'
//   const [selectedCompanyId, setSelectedCompanyId] = useState(null); // To store selected company ID
// const handleClockInTimeChange = (value) => {
//     if (errors.clockInTime) {
//       setErrors((prev) => ({ ...prev, clockInTime: false }));
//     }
//   setClockInTime(value); // Keep it as Date object
// };

// const handleClockOutTimeChange = (value) => {
//   if (errors.clockOutTime) {
//       setErrors((prev) => ({ ...prev, clockOutTime: false }));
//     }
//   setClockOutTime(value); // Keep it as Date object
// };

//   const jobInputRef = useRef(null);
//   const costInputRef = useRef(null);
//   const empInputRef = useRef(null);

//   const fetchTabsData = async () => {
//     try {
//       const response = await api.get(`/v1/timesheets/company-details`);

//       if (response.status === 200) {
//         const companies = response.data;
//         setCompanyTabs(companies);

//         if (companyname) {
//           const matchedCompany = companies.find(
//             (company) => company.name.toLowerCase() === companyname.toLowerCase()
//           );
//           if (matchedCompany) {
//             setSelectedCompanyId(matchedCompany.id);
//           } else {
//             setSelectedCompanyId(companies[0]?.id); // fallback if name not matched
//           }
//         } else {
//           setSelectedCompanyId(companies[0]?.id);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }finally{

//     }
//   };

//   useEffect(()=>{
//     fetchTabsData()
//   },[])
// const validateForm = () => {
//   let newErrors = {};
//   if (!employeeId) newErrors.employeeId = true;
//   if (!jobCode) newErrors.jobCode = true;
//   if (!costCode) newErrors.costCode = true;
//   if (!clockInTime) newErrors.clockInTime = true;
//   if (!clockOutTime) newErrors.clockOutTime = true;
//   if (!selectdate) newErrors.selectdate = true;
//   if (!breakTime) newErrors.breakTime = true;
//   if (!perDiem) newErrors.perDiem = true;

//   setErrors(newErrors);
//   return Object.keys(newErrors).length === 0;
// };

// const getInputBorderClass = (field) => {
//   return errors[field] ? "border-red-500" : "border-gray-300";
// };

//   const fetchJobSuggestions = async (query) => {
//     try {
//        setLoadingJobs(true);
//       if (!query) {
//         setSuggestions([]);
//         setShowSuggestions(false);
//         setSelectedJobName('');
//         return;
//       }
//       const response = await api.get(`/v1/timesheets/get-jobs`, {
//         params: {
//           company_id: selectedCompanyId,
//           job_num :query,
//         }
//       });
// if(response.status==201){
//   setJobNotFound(true)
// }

//       let fetchedSuggestions = response.status === 200 ? response.data || [] : [];
// if(response.status==200){
//   setJobNotFound(false)
// }
//       // Manually include "0000 - Overhead" if relevant
//       if (/^0{1,4}$/.test(query)) {
//         const overheadJob = {
//           job_num: "0000",
//           job_name: "Overhead"
//         };

//         // Avoid duplicates
//         const alreadyExists = fetchedSuggestions.some(job => job.job_num === "0000");
//         if (!alreadyExists) {
//           fetchedSuggestions = [overheadJob, ...fetchedSuggestions];
//         }
//     setJobNotFound(false)

//       }

//       setSuggestions(fetchedSuggestions);
//       setShowSuggestions(true);

//     } catch (error) {
//        setJobNotFound(true)
//       console.error("Error fetching jobcodes:", error);
//     }
//     finally {
//     setLoadingJobs(false);
//   }
//   };

//   const fetchCostSuggestions = async (query) => {
//     try {
//         setLoadingCostCodes(true);
//       if (!query) {
//         setCosts([]);
//         setShowCostSuggestions(false);
//         return;
//       }
//       const response = await api.get(`/v1/timesheets/get-costcodes`,{
//         params: {
//           company_id: selectedCompanyId,
//           cost_code:query,
//         }
//       });
//       if (response.status === 200) {
//         setCosts(response.data || []);
//         setShowCostSuggestions(true);
//         setCostNotFound(false)
//       }else{
//         setCostCode('')
//         setCosts([])
//         setCostNotFound(true)
//         setShowCostSuggestions(false)
//       }
//     } catch (error) {
//          setCostNotFound(true)
//       console.error("Error fetching cost codes:", error);
//     }
//     finally {
//     setLoadingCostCodes(false);
//   }
//   };

//   const fetchEmployeeSuggestions = async (query) => {
//     try {
//         setLoadingEmployees(true);
//       if (!query) {
//         setEmployeeSuggestions([]);
//         setShowEmpSuggestions(false);
//         return;
//       }

//       const obj = {
//         params: {
//           company_id:selectedCompanyId,
//           empid: query
//         },
//       };

//       const response = await api.get("/v1/timesheets/get-employee", obj);
//       if (response.status === 200 && Array.isArray(response.data)) {
//         setEmployeeSuggestions(response.data);
//         setShowEmpSuggestions(true);
//       }else{
//         setEmployeeSuggestions([]);
//         setShowEmpSuggestions(false);
//         setEmployeeId("")

//       }
//     } catch (error) {
//       console.error("Error fetching employee suggestions:", error);
//     }
//     finally {
//     setLoadingEmployees(false);
//   }
//   };

//   const handleJobCodeSelect = (code) => {
//     setJobCode(code.job_num);
//     setSelectedJobName(code.job_name);
//     setSuggestions([]);
//     setShowSuggestions(false);
//   };

//   const handleCostCodeSelect = (code) => {
//     setCostCode(code.cost_code);
//     setSelectedCostDescription(code.costcode_name);
//     setCosts([]);
//     setShowCostSuggestions(false);
//   };

//   const handleEmployeeSelect = (emp) => {
//     setEmployeeId(emp.empid); // Set input value to empid
//     setselectedempobj(emp);   // Store full emp object for displaying name
//     setEmployeeSuggestions([]);
//     setShowEmpSuggestions(false);
//   };

//   const isFormValid = () => {
//     return jobCode && costCode && employeeId && clockInTime && clockOutTime&&selectdate;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//      if (!validateForm()) {
//     setSeverity("error");
//     setAlertMessage("Please fill all required fields.");
//     setOpen(true);
//     return;
//   }
//  if(costNotFound){
//      setSeverity("error")
//       setAlertMessage('Cost Code Not Found')
//       setOpen(true)
//       return
//   }
//    if(jobNotFound){
//      setSeverity("error")
//       setAlertMessage('Job Code Not Found')
//       setOpen(true)
//       return
//   }
//     const formData = {
//       employeeId:employeeId,
//       jobCode,
//       costCode,
//       clockInDate,
//       clockInTime,
//       clockOutTime,
//       breakTime,
//       perDiem,
//       classification,
//       selectdate
//     };

//  function formatTimeOnly(dateObj) {
//   if (!dateObj) return null;
//   const hours = String(dateObj.getHours()).padStart(2, '0');
//   const minutes = String(dateObj.getMinutes()).padStart(2, '0');
//   return `${hours}:${minutes}:00`;
// }

// const formattedClockIn = formatTimeOnly(clockInTime);
// const formattedClockOut = formatTimeOnly(clockOutTime);

// const formattedDate = selectdate ? format(selectdate, 'yyyy-MM-dd') : '';
//     try {
//       const response = await api.post(`v1/timesheets/create`, {
//         companyid:selectedCompanyId,
//         supervisorid: queryParams.get("supervisorid"),
//         classification: selectedempobj.classification,
//         emp_id: employeeId,
//         emp_name:`${selectedempobj.firstname} ${selectedempobj.lastname}` ,
//         job_id: jobCode,
//         jobname: selectedJobName,
//         cost_code_id: costCode,
//         costcodename: selectedCostDescription,
//         date:formattedDate,
//         clock_in: formattedClockIn,
//         clock_out: formattedClockOut,
//         break_time: breakTime,
//         perdim: perDiem,
//       });
// if(response.status==200){
//   setAlertMessage("Employee time added successfully.");
//   setSeverity("success");
//   setOpen(true);
//   fetchdata()
//   setEmpModal(false)
// }else{
//   setAlertMessage(response?.message||'Something went wrong');
//   setSeverity("info");
//   setOpen(true);
// }

//     } catch (error) {
//       console.log(error);
//     } finally {

//     }
//   };
//   const handleDtChange = (date) => {
//     setSelectdate(date);
//   };
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (jobInputRef.current && !jobInputRef.current.contains(event.target)) {
//         setShowSuggestions(false);
//       }
//       if (costInputRef.current && !costInputRef.current.contains(event.target)) {
//         setShowCostSuggestions(false);
//       }
//       if (empInputRef.current && !empInputRef.current.contains(event.target)) {
//         setShowEmpSuggestions(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 overflow-y-auto custom-scrollbar">
//       <div className="relative w-[90%] max-w-3xl px-6 py-6 mt-20 mb-4 bg-white rounded-lg border border-gray-300 shadow-sm">
//         <div className="flex justify-between items-center border-b pb-4">
//           <h2 className="text-xl font-semibold font-poppins">Add Employee Time</h2>
//           <button onClick={() => setEmpModal(false)} className="text-gray-500 hover:text-gray-700">
//             <CloseIcon />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit} className="mt-6 space-y-4">
//         <div>
//       <label className="block text-sm text-left font-medium">Company</label>
//       <select
//   className="w-full border rounded px-3 py-2"
//   value={selectedCompanyId || ""}
//   onChange={(e) => {
//     const selectedId = parseInt(e.target.value, 10);
//     setSelectedCompanyId(selectedId);
//   }}
// >
//   <option value="">Select a Company</option>
//   {companyTabs.map((company) => (
//     <option key={company.id} value={company.id}>
//       {company.name}
//     </option>
//   ))}
// </select>

//     </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div className="relative" ref={empInputRef}>
//   <label className="block text-sm text-left font-medium">Employee Id</label>
//   <div className="relative">
//     <input
//       type="text"
//       placeholder="Employee Id"
//   className={`w-full border rounded px-3 py-2 ${getInputBorderClass("employeeId")}`}
//       value={employeeId}
//       onChange={(e) => {
//        const val = e.target.value.replace(/\D/g, ''); // Remove any non-numeric characters
// setEmployeeId(val);

//           if (errors.employeeId) {
//       setErrors((prev) => ({ ...prev, employeeId: false }));
//     }
//         if (!val.trim()) {
//           setselectedempobj({});
//           setEmployeeSuggestions([]);
//           setShowEmpSuggestions(false);
//         } else {
//           fetchEmployeeSuggestions(val);
//         }

//       }}
//         onKeyDown={(e) => {
//     if (showEmpSuggestions && employeeSuggestions.length > 0) {
//       if (e.key === 'ArrowDown') {
//         e.preventDefault();
//         setEmpFocusedIndex((prevIndex) =>
//           prevIndex < employeeSuggestions.length - 1 ? prevIndex + 1 : 0
//         );
//       } else if (e.key === 'ArrowUp') {
//         e.preventDefault();
//         setEmpFocusedIndex((prevIndex) =>
//           prevIndex > 0 ? prevIndex - 1 : employeeSuggestions.length - 1
//         );
//       } else if (e.key === 'Enter' || e.key === 'Tab') {
//         if (empFocusedIndex >= 0) {
//           e.preventDefault();
//           handleEmployeeSelect(employeeSuggestions[empFocusedIndex]);
//         }
//       }
//     }
//   }}
//     />
//     <button type="button" className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500">
//       <SearchIcon />
//     </button>
//   </div>

//   {/* Show Employee Name */}
//   {selectedempobj?.firstname && (
//     <p className="text-sm text-gray-600 mt-1 text-left">
//       {selectedempobj.firstname} {selectedempobj.lastname}
//     </p>
//   )}

//   {/* Suggestion List */}
//  {showEmpSuggestions && (
//   <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[300px] overflow-y-auto text-sm w-full">
//     {loadingEmployees ? (
//       <div className="p-2 text-gray-500 flex w-full justify-center items-center">
//         <CircularProgress size={20} />
//       </div>
//     ) : employeeSuggestions.length === 0 ? (
//       <li className="px-3 flex w-full justify-center py-2 text-gray-500">
//         No results found.
//       </li>
//     ) : (
//       employeeSuggestions.map((emp, index) => (
//         <li
//           key={index}
//           onClick={() => handleEmployeeSelect(emp)}
//             onMouseEnter={() => setEmpFocusedIndex(index)}
//           className={`px-2 py-1 cursor-pointer ${
//             empFocusedIndex === index ? 'bg-gray-200' : 'hover:bg-gray-100'
//           }`}
//         >
//           {`${emp.firstname} ${emp.lastname}`} - {emp.empid}
//         </li>
//       ))
//     )}
//   </ul>
// )}

// </div>

//             <div className="relative" ref={jobInputRef}>
//               <label className="block text-sm text-left font-medium">Job Number</label>
//               <input
//                 type="text"
//                 placeholder="Job Number"
//                 value={jobCode}
//                 onChange={(e) => {
//                   const val = e.target.value;
//                   setJobCode(val);
//                   setSelectedJobName('');
//                   fetchJobSuggestions(val);
//                     setJobFocusedIndex(-1); // Reset on change
//                       if (errors.jobCode) {
//       setErrors((prev) => ({ ...prev, jobCode: false }));
//     }
//                 }}
//                   onKeyDown={(e) => {
//     if (showSuggestions && suggestions.length > 0) {
//       if (e.key === 'ArrowDown') {
//         e.preventDefault();
//         setJobFocusedIndex((prev) =>
//           prev < suggestions.length - 1 ? prev + 1 : 0
//         );
//       } else if (e.key === 'ArrowUp') {
//         e.preventDefault();
//         setJobFocusedIndex((prev) =>
//           prev > 0 ? prev - 1 : suggestions.length - 1
//         );
//       } else if (e.key === 'Enter' || e.key === 'Tab') {
//         if (jobFocusedIndex >= 0) {
//           e.preventDefault();
//           handleJobCodeSelect(suggestions[jobFocusedIndex]);
//         }
//       }
//     }
//   }}
//          className={`w-full border rounded px-3 py-2 ${getInputBorderClass("jobCode")}`}
//               />
//                   {selectedJobName && (
//   <p className="text-sm text-gray-600 text-left mt-1">{selectedJobName}</p>
// )}
//        {jobNotFound&&<p className="text-xs text-red-500 mt-1">No Job code found</p>}
//            {showSuggestions && (
//   <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[150px] overflow-y-auto custom-scrollbar text-sm w-full whitespace-nowrap">
//     {loadingJobs ? (
//       <div className="p-2 text-gray-500 flex w-full justify-center items-center">
//         <CircularProgress size={20} />
//       </div>
//     ) : suggestions.length === 0 ? (
//       <li className="px-3 flex w-full justify-center py-2 text-gray-500">
//         No results found.
//       </li>
//     ) : (
//       suggestions.map((code, index) => (
//         <li
//           key={index}
//           onClick={() => handleJobCodeSelect(code)}
//           onMouseEnter={() => setJobFocusedIndex(index)}
//   className={`px-2 py-1 cursor-pointer ${
//     jobFocusedIndex === index ? 'bg-gray-200' : 'hover:bg-gray-100'
//   }`}
//         >
//           {code.job_num} - {code.job_name}
//         </li>
//       ))
//     )}
//   </ul>
// )}

//             </div>

//           </div>

//           <div className="w-full">
//             <div className="relative" ref={costInputRef}>
//               <label className="block text-sm text-left font-medium">Cost Code</label>
//               <input
//                 type="text"
//                 placeholder="Cost Code"
//                 value={costCode}
//                 onChange={(e) => {
//                   const val = e.target.value;
//                   setCostCode(val);
//                   setSelectedCostDescription('');
//                   fetchCostSuggestions(val);
//                     if (errors.costCode) {
//       setErrors((prev) => ({ ...prev, costCode: false }));
//     }
//                     setCostFocusedIndex(-1); // Reset
//                 }}
//                  onKeyDown={(e) => {
//     if (showCostSuggestions && costs.length > 0) {
//       if (e.key === 'ArrowDown') {
//         e.preventDefault();
//         setCostFocusedIndex((prev) =>
//           prev < costs.length - 1 ? prev + 1 : 0
//         );
//       } else if (e.key === 'ArrowUp') {
//         e.preventDefault();
//         setCostFocusedIndex((prev) =>
//           prev > 0 ? prev - 1 : costs.length - 1
//         );
//       } else if (e.key === 'Enter' || e.key === 'Tab') {
//         if (costFocusedIndex >= 0) {
//           e.preventDefault();
//           handleCostCodeSelect(costs[costFocusedIndex]);
//         }
//       }
//     }
//   }}
//    className={`w-full border rounded px-3 py-2 ${getInputBorderClass("costCode")}`}
//               />
//               {selectedCostDescription && (
//   <p className="text-sm text-gray-600 text-left mt-1">{selectedCostDescription}</p>
// )}
//  {costNotFound&&<p className="text-xs text-red-500 mt-1">No Cost code found</p>}

//             {showCostSuggestions && (
//   <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[200px] overflow-y-auto custom-scrollbar text-sm w-full whitespace-nowrap">
//     {loadingCostCodes ? (
//       <div className="p-2 text-gray-500 flex w-full justify-center items-center">
//         <CircularProgress size={20} />
//       </div>
//     ) : costs.length === 0 ? (
//       <li className="px-3 flex w-full justify-center py-2 text-gray-500">
//         No results found.
//       </li>
//     ) : (
//       costs.map((code, index) => (
//         <li
//           key={index}
//           onClick={() => handleCostCodeSelect(code)}
//         onMouseEnter={() => setCostFocusedIndex(index)}
//   className={`px-2 py-1 cursor-pointer ${
//     costFocusedIndex === index ? 'bg-gray-200' : 'hover:bg-gray-100'
//   }`}
//         >
//           {code.cost_code} - {code.costcode_name}
//         </li>
//       ))
//     )}
//   </ul>
// )}

//             </div>
//             <div className="flex gap-4">
//   <div className="w-[50%] flex flex-col items-start justify-start">
//     <label className="block text-sm text-left font-medium my-2">Clock In Time</label>
//     <div className="flex items-center justify-center w-full border border-[#E4E4E7] bg-white rounded-[6px]">
//      <TimePicker
//       format="hh:mm aa"
//       showMeridiem
//       value={clockInTime}
//       onChange={handleClockInTimeChange}
//      className={`w-full text-sm border rounded ${getInputBorderClass("clockInTime")}`}
//     />
//     </div>
//   </div>

//   <div className="w-[50%] flex flex-col items-start justify-start">
//     <label className="block text-sm text-left font-medium my-2">Clock Out Time</label>
//     <div className="flex items-center justify-center w-full border border-[#E4E4E7] bg-white rounded-[6px]">
//       <TimePicker
//       value={clockOutTime}
//   onChange={handleClockOutTimeChange}
//       format="hh:mm aa"
//   showMeridiem
//       //  style={{ zIndex: 1001 }} // Add a high z-index here
// className={`w-full text-sm border rounded ${getInputBorderClass("clockOutTime")}`}

//     />
//     </div>
//   </div>
// </div>

//           </div>

//           <div className="w-full">
//             <div>
//               <label className="block text-sm text-left font-medium">Break Time (Minutes)</label>
//               <input
//                 type="number"
//                 value={breakTime}
//                 onChange={(e) => {
//                     if (errors.breakTime) {
//       setErrors((prev) => ({ ...prev, breakTime: false }));
//     }
//                   setBreakTime(e.target.value)}}
//    className={`w-full border rounded px-3 py-2 ${getInputBorderClass("breakTime")}`}
//                 min="0"
//               />
//             </div>

//             <div className="w-full flex gap-4">
//               <div className='w-1/2'>
//   <label className="block text-sm text-left font-medium">Per Diem ($)</label>
//               <input
//                 type="text"
//                 value={perDiem}
//                 onChange={(e) => {
//                     if (errors.perDiem) {
//       setErrors((prev) => ({ ...prev, perDiem: false }));
//     }
//                     setPerDiem(e.target.value)}}
//           className={`w-full border rounded px-3 py-2 ${getInputBorderClass("perDiem")}`}
//                 min="0"
//               />

//               </div>
//               <div className='w-1/2 '>
//   <label className="block text-sm text-left font-medium mb-1">Select Date</label>
//   <DatePicker
//     selected={selectdate}
//     onChange={handleDtChange}
//     className="w-full border rounded px-3 py-2"         // Input field
//     wrapperClassName="w-full"                           // Outer wrapper
//     dateFormat="MM-dd-yyyy"
//   />
// </div>

//             </div>
//           </div>

//           <div className="mt-4 flex justify-end w-full">
//             <button
//               type="submit"
//               // disabled={!isFormValid()}
//               className={`px-6 py-2  text-white rounded-lg ${!isFormValid() ? 'bg-[#944f4f]' : 'bg-[#8B1D1D]'}`}
//             >
//               Save Changes
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EmpModal;

import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import api from "../../api/api";
import { useLocation } from "react-router-dom";
import { set } from "date-fns";
import { DateTime } from "luxon";

import "react-time-picker/dist/TimePicker.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TimePicker, Stack } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { parse, format, isValid } from "date-fns";
import dayjs from "dayjs";
import { CircularProgress } from "@mui/material";
const EmpModal = ({
  setEmpModal,
  previousdate,
  group_by,
  setAlertMessage,
  fetchdata,
  setSeverity,
  setOpen,
}) => {
  const today = new Date().toISOString().split("T")[0];
  const [suggestions, setSuggestions] = useState([]);
  const [costs, setCosts] = useState([]);
  const [errors, setErrors] = useState({});

  const [employeeSuggestions, setEmployeeSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showCostSuggestions, setShowCostSuggestions] = useState(false);
  const [showEmpSuggestions, setShowEmpSuggestions] = useState(false);
  const [jobCode, setJobCode] = useState("");
  const [costCode, setCostCode] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [selectedJobName, setSelectedJobName] = useState("");
  const [selectedCostDescription, setSelectedCostDescription] = useState("");
  const [clockInDate, setClockInDate] = useState(today);
  const [clockInTime, setClockInTime] = useState("");
  const [clockOutTime, setClockOutTime] = useState("");
  const [breakTime, setBreakTime] = useState(0);
  const [selectedempobj, setselectedempobj] = useState({});
  const [perDiem, setPerDiem] = useState("");
  const location = useLocation();
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [loadingJobs, setLoadingJobs] = useState(false);
  const [loadingCostCodes, setLoadingCostCodes] = useState(false);
  const [empFocusedIndex, setEmpFocusedIndex] = useState(-1);
  const [jobFocusedIndex, setJobFocusedIndex] = useState(-1);
  const [costFocusedIndex, setCostFocusedIndex] = useState(-1);
  const [jobNotFound, setJobNotFound] = useState(false);
  const [costNotFound, setCostNotFound] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const date = queryParams.get("date");
  const companyname = queryParams.get("company");
  const [selectdate, setSelectdate] = useState(() => {
    if (previousdate) {
      return dayjs(previousdate).toDate(); // ✅ prefer previousdate if provided
    } else if (date) {
      return dayjs(date, "YYYY-MM-DD").toDate(); // ✅ query param date
    } else {
      return dayjs().toDate(); // ✅ fallback current date
    }
  });

  const [classification, setClassification] = useState("");
  const [companyTabs, setCompanyTabs] = useState([]); // Replaces 'Tabs'
  const [selectedCompanyId, setSelectedCompanyId] = useState(null); // To store selected company ID
  const handleClockInTimeChange = (value) => {
    if (errors.clockInTime) {
      setErrors((prev) => ({ ...prev, clockInTime: false }));
    }
    setClockInTime(value); // Keep it as Date object
  };

  const handleClockOutTimeChange = (value) => {
    if (errors.clockOutTime) {
      setErrors((prev) => ({ ...prev, clockOutTime: false }));
    }
    setClockOutTime(value); // Keep it as Date object
  };

  const jobInputRef = useRef(null);
  const costInputRef = useRef(null);
  const empInputRef = useRef(null);

  const fetchTabsData = async () => {
    try {
      const response = await api.get(`/v1/timesheets/company-details`);

      if (response.status === 200) {
        const companies = response.data;
        setCompanyTabs(companies);

        if (companyname) {
          const matchedCompany = companies.find(
            (company) =>
              company.name.toLowerCase() === companyname.toLowerCase(),
          );
          if (matchedCompany) {
            setSelectedCompanyId(matchedCompany.id);
          } else {
            setSelectedCompanyId(companies[0]?.id); // fallback if name not matched
          }
        } else {
          setSelectedCompanyId(companies[0]?.id);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchTabsData();
  }, []);
  const validateForm = () => {
    let newErrors = {};
    if (!employeeId) newErrors.employeeId = true;
    if (!jobCode) newErrors.jobCode = true;
    if (!costCode) newErrors.costCode = true;
    if (!clockInTime) newErrors.clockInTime = true;
    if (!clockOutTime) newErrors.clockOutTime = true;
    if (!selectdate) newErrors.selectdate = true;
    if (!breakTime) newErrors.breakTime = true;
    if (!perDiem) newErrors.perDiem = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getInputBorderClass = (field) => {
    return errors[field] ? "border-red-500" : "border-gray-300";
  };

  const fetchJobSuggestions = async (query) => {
    try {
      setLoadingJobs(true);
      if (!query) {
        setSuggestions([]);
        setShowSuggestions(false);
        setSelectedJobName("");
        return;
      }
      const response = await api.get(`/v1/timesheets/get-jobs`, {
        params: {
          company_id: selectedCompanyId,
          job_num: query,
        },
      });
      if (response.status == 201) {
        setJobNotFound(true);
      }

      let fetchedSuggestions =
        response.status === 200 ? response.data || [] : [];
      if (response.status == 200) {
        setJobNotFound(false);
      }
      // Manually include "0000 - Overhead" if relevant
      if (/^0{1,4}$/.test(query)) {
        const overheadJob = {
          job_num: "0000",
          job_name: "Overhead",
        };

        // Avoid duplicates
        const alreadyExists = fetchedSuggestions.some(
          (job) => job.job_num === "0000",
        );
        if (!alreadyExists) {
          fetchedSuggestions = [overheadJob, ...fetchedSuggestions];
        }
        setJobNotFound(false);
      }

      setSuggestions(fetchedSuggestions);
      setShowSuggestions(true);
    } catch (error) {
      setJobNotFound(true);
      console.error("Error fetching jobcodes:", error);
    } finally {
      setLoadingJobs(false);
    }
  };

  // const fetchCostSuggestions = async (query) => {
  //   try {
  //       setLoadingCostCodes(true);
  //     if (!query) {
  //       setCosts([]);
  //       setShowCostSuggestions(false);
  //       return;
  //     }
  //     const response = await api.get(`/v1/timesheets/get-costcodes`,{
  //       params: {
  //         company_id: selectedCompanyId,
  //         cost_code:query,
  //       }
  //     });
  //     if (response.status === 200) {
  //       setCosts(response.data || []);
  //       setShowCostSuggestions(true);
  //       setCostNotFound(false)
  //     }else{
  //       setCostCode('')
  //       setCosts([])
  //       setCostNotFound(true)
  //       setShowCostSuggestions(false)
  //     }
  //   } catch (error) {
  //        setCostNotFound(true)
  //     console.error("Error fetching cost codes:", error);
  //   }
  //   finally {
  //   setLoadingCostCodes(false);
  // }
  // };

  const fetchCostSuggestions = async (query) => {
    try {
      setLoadingCostCodes(true);

      if (query === "0000") {
        setCosts([]);
        setShowCostSuggestions(false);
        return;
      }

      if (/^0{1,4}$/.test(query)) {
        const overheadCost = {
          cost_code: "0000",
          costcode_name: "Overhead",
        };

        setCosts([overheadCost]);
        setShowCostSuggestions(true);
        setCostNotFound(false);
        setLoadingCostCodes(false);
        return;
      }

      const response = await api.get(`/v1/timesheets/get-costcodes`, {
        params: {
          company_id: selectedCompanyId,
          cost_code: query,
        },
      });

      if (response.status === 200) {
        const fetchedCostSuggestions = response.data || [];

        if (/^0{1,4}$/.test(query)) {
          const overheadCost = {
            cost_code: "0000",
            costcode_name: "Overhead",
          };

          const alreadyExists = fetchedCostSuggestions.some(
            (cost) => cost.cost_code === "0000",
          );

          if (!alreadyExists) {
            fetchedCostSuggestions.unshift(overheadCost);
          }
        }

        console.log("Fetched Cost Suggestions:", fetchedCostSuggestions);
        setCosts(fetchedCostSuggestions);
        setShowCostSuggestions(true);
        setCostNotFound(false);
      } else {
        setCostCode("");
        setCosts([]);
        setCostNotFound(true);
        setShowCostSuggestions(false);
      }
    } catch (error) {
      setCostNotFound(true);
      console.error("Error fetching cost codes:", error);
    } finally {
      setLoadingCostCodes(false);
    }
  };

  const fetchEmployeeSuggestions = async (query) => {
    try {
      setLoadingEmployees(true);
      if (!query) {
        setEmployeeSuggestions([]);
        setShowEmpSuggestions(false);
        return;
      }

      const obj = {
        params: {
          company_id: selectedCompanyId,
          empid: query,
        },
      };

      const response = await api.get("/v1/timesheets/get-employee", obj);
      if (response.status === 200 && Array.isArray(response.data)) {
        setEmployeeSuggestions(response.data);
        setShowEmpSuggestions(true);
      } else {
        setEmployeeSuggestions([]);
        setShowEmpSuggestions(false);
        setEmployeeId("");
      }
    } catch (error) {
      console.error("Error fetching employee suggestions:", error);
    } finally {
      setLoadingEmployees(false);
    }
  };

  const handleJobCodeSelect = (code) => {
    setJobCode(code.job_num);
    setSelectedJobName(code.job_name);
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const handleCostCodeSelect = (code) => {
    setCostCode(code.cost_code);
    setSelectedCostDescription(code.costcode_name);
    setCosts([]);
    setShowCostSuggestions(false);
  };

  const handleEmployeeSelect = (emp) => {
    setEmployeeId(emp.empid); // Set input value to empid
    setselectedempobj(emp); // Store full emp object for displaying name
    setEmployeeSuggestions([]);
    setShowEmpSuggestions(false);
  };

  const isFormValid = () => {
    return (
      jobCode &&
      costCode &&
      employeeId &&
      clockInTime &&
      clockOutTime &&
      selectdate
    );
  };
  const toUTC = (time) => {
    if (!time) return time;

    const today = dayjs().format("YYYY-MM-DD");
    const fullTime = `${today} ${time}`; // ✅ fixed

    return dayjs
      .tz(fullTime, "YYYY-MM-DD HH:mm:ss", "America/Regina")
      .utc()
      .subtract(1, "hour")
      .format("HH:mm");
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      setSeverity("error");
      setAlertMessage("Please fill all required fields.");
      setOpen(true);
      return;
    }
    if (costNotFound) {
      setSeverity("error");
      setAlertMessage("Cost Code Not Found");
      setOpen(true);
      return;
    }
    if (jobNotFound) {
      setSeverity("error");
      setAlertMessage("Job Code Not Found");
      setOpen(true);
      return;
    }
    const formData = {
      employeeId: employeeId,
      jobCode,
      costCode,
      clockInDate,
      clockInTime,
      clockOutTime,
      breakTime,
      perDiem,
      classification,
      selectdate,
    };

    function formatTimeOnly(dateObj) {
      if (!dateObj) return null;
      const hours = String(dateObj.getHours()).padStart(2, "0");
      const minutes = String(dateObj.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}:00`;
    }
    const localClockIn = formatTimeOnly(clockInTime);
    const localClockOut = formatTimeOnly(clockOutTime);

    const formattedClockIn = toUTC(localClockIn);
    const formattedClockOut = toUTC(localClockOut);

    const formattedDate = selectdate ? format(selectdate, "yyyy-MM-dd") : "";
    try {
      const response = await api.post(`v1/timesheets/create`, {
        companyid: selectedCompanyId,
        supervisorid: queryParams.get("supervisorid"),
        classification: selectedempobj.classification,
        emp_id: employeeId,
        emp_name: `${selectedempobj.firstname} ${selectedempobj.lastname}`,
        job_id: jobCode,
        jobname: selectedJobName,
        cost_code_id: costCode,
        costcodename: selectedCostDescription,
        date: formattedDate,
        clock_in: formattedClockIn,
        clock_out: formattedClockOut,
        break_time: breakTime,
        perdim: perDiem,
      });
      if (response.status == 200) {
        setAlertMessage("Employee time added successfully.");
        setSeverity("success");
        setOpen(true);
        fetchdata();
        setEmpModal(false);
      } else {
        setAlertMessage(response?.message || "Something went wrong");
        setSeverity("info");
        setOpen(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const handleDtChange = (date) => {
    setSelectdate(date);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (jobInputRef.current && !jobInputRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
      if (
        costInputRef.current &&
        !costInputRef.current.contains(event.target)
      ) {
        setShowCostSuggestions(false);
      }
      if (empInputRef.current && !empInputRef.current.contains(event.target)) {
        setShowEmpSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 overflow-y-auto custom-scrollbar">
      <div className="relative w-[90%] max-w-3xl px-6 py-6 mt-20 mb-4 bg-white rounded-lg border border-gray-300 shadow-sm">
        <div className="flex justify-between items-center border-b pb-4">
          <h2 className="text-xl font-semibold font-poppins">
            Add Employee Time
          </h2>
          <button
            onClick={() => setEmpModal(false)}
            className="text-gray-500 hover:text-gray-700"
          >
            <CloseIcon />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <label className="block text-sm text-left font-medium">
              Company
            </label>
            <select
              className="w-full border rounded px-3 py-2"
              value={selectedCompanyId || ""}
              onChange={(e) => {
                const selectedId = parseInt(e.target.value, 10);
                setSelectedCompanyId(selectedId);
              }}
            >
              <option value="">Select a Company</option>
              {companyTabs.map((company) => (
                <option key={company.id} value={company.id}>
                  {company.name}
                </option>
              ))}
            </select>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="relative" ref={empInputRef}>
              <label className="block text-sm text-left font-medium">
                Employee Id
              </label>
              <div className="relative">
                <input
                  type="text"
                  placeholder="Employee Id"
                  className={`w-full border rounded px-3 py-2 ${getInputBorderClass(
                    "employeeId",
                  )}`}
                  value={employeeId}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, ""); // Remove any non-numeric characters
                    setEmployeeId(val);

                    if (errors.employeeId) {
                      setErrors((prev) => ({ ...prev, employeeId: false }));
                    }
                    if (!val.trim()) {
                      setselectedempobj({});
                      setEmployeeSuggestions([]);
                      setShowEmpSuggestions(false);
                    } else {
                      fetchEmployeeSuggestions(val);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (showEmpSuggestions && employeeSuggestions.length > 0) {
                      if (e.key === "ArrowDown") {
                        e.preventDefault();
                        setEmpFocusedIndex((prevIndex) =>
                          prevIndex < employeeSuggestions.length - 1
                            ? prevIndex + 1
                            : 0,
                        );
                      } else if (e.key === "ArrowUp") {
                        e.preventDefault();
                        setEmpFocusedIndex((prevIndex) =>
                          prevIndex > 0
                            ? prevIndex - 1
                            : employeeSuggestions.length - 1,
                        );
                      } else if (e.key === "Enter" || e.key === "Tab") {
                        if (empFocusedIndex >= 0) {
                          e.preventDefault();
                          handleEmployeeSelect(
                            employeeSuggestions[empFocusedIndex],
                          );
                        }
                      }
                    }
                  }}
                />
                <button
                  type="button"
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500"
                >
                  <SearchIcon />
                </button>
              </div>

              {/* Show Employee Name */}
              {selectedempobj?.firstname && (
                <p className="text-sm text-gray-600 mt-1 text-left">
                  {selectedempobj.firstname} {selectedempobj.lastname}
                </p>
              )}

              {/* Suggestion List */}
              {showEmpSuggestions && (
                <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[300px] overflow-y-auto text-sm w-full">
                  {loadingEmployees ? (
                    <div className="p-2 text-gray-500 flex w-full justify-center items-center">
                      <CircularProgress size={20} />
                    </div>
                  ) : employeeSuggestions.length === 0 ? (
                    <li className="px-3 flex w-full justify-center py-2 text-gray-500">
                      No results found.
                    </li>
                  ) : (
                    employeeSuggestions.map((emp, index) => (
                      <li
                        key={index}
                        onClick={() => handleEmployeeSelect(emp)}
                        onMouseEnter={() => setEmpFocusedIndex(index)}
                        className={`px-2 py-1 cursor-pointer ${
                          empFocusedIndex === index
                            ? "bg-gray-200"
                            : "hover:bg-gray-100"
                        }`}
                      >
                        {`${emp.firstname} ${emp.lastname}`} - {emp.empid}
                      </li>
                    ))
                  )}
                </ul>
              )}
            </div>

            <div className="relative" ref={jobInputRef}>
              <label className="block text-sm text-left font-medium">
                Job Number
              </label>
              <input
                type="text"
                placeholder="Job Number"
                value={jobCode}
                onChange={(e) => {
                  const val = e.target.value;
                  setJobCode(val);
                  setSelectedJobName("");
                  fetchJobSuggestions(val);
                  setJobFocusedIndex(-1); // Reset on change
                  if (errors.jobCode) {
                    setErrors((prev) => ({ ...prev, jobCode: false }));
                  }
                }}
                onKeyDown={(e) => {
                  if (showSuggestions && suggestions.length > 0) {
                    if (e.key === "ArrowDown") {
                      e.preventDefault();
                      setJobFocusedIndex((prev) =>
                        prev < suggestions.length - 1 ? prev + 1 : 0,
                      );
                    } else if (e.key === "ArrowUp") {
                      e.preventDefault();
                      setJobFocusedIndex((prev) =>
                        prev > 0 ? prev - 1 : suggestions.length - 1,
                      );
                    } else if (e.key === "Enter" || e.key === "Tab") {
                      if (jobFocusedIndex >= 0) {
                        e.preventDefault();
                        handleJobCodeSelect(suggestions[jobFocusedIndex]);
                      }
                    }
                  }
                }}
                className={`w-full border rounded px-3 py-2 ${getInputBorderClass(
                  "jobCode",
                )}`}
              />
              {selectedJobName && (
                <p className="text-sm text-gray-600 text-left mt-1">
                  {selectedJobName}
                </p>
              )}
              {jobNotFound && (
                <p className="text-xs text-red-500 mt-1">No Job code found</p>
              )}
              {showSuggestions && (
                <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[150px] overflow-y-auto custom-scrollbar text-sm w-full whitespace-nowrap">
                  {loadingJobs ? (
                    <div className="p-2 text-gray-500 flex w-full justify-center items-center">
                      <CircularProgress size={20} />
                    </div>
                  ) : suggestions.length === 0 ? (
                    <li className="px-3 flex w-full justify-center py-2 text-gray-500">
                      No results found.
                    </li>
                  ) : (
                    suggestions.map((code, index) => (
                      <li
                        key={index}
                        onClick={() => handleJobCodeSelect(code)}
                        onMouseEnter={() => setJobFocusedIndex(index)}
                        className={`px-2 py-1 cursor-pointer ${
                          jobFocusedIndex === index
                            ? "bg-gray-200"
                            : "hover:bg-gray-100"
                        }`}
                      >
                        {code.job_num} - {code.job_name}
                      </li>
                    ))
                  )}
                </ul>
              )}
            </div>
          </div>

          <div className="w-full">
            <div className="relative" ref={costInputRef}>
              <label className="block text-sm text-left font-medium">
                Cost Code
              </label>
              <input
                type="text"
                placeholder="Cost Code"
                value={costCode}
                onChange={(e) => {
                  const val = e.target.value;
                  setCostCode(val);
                  setSelectedCostDescription("");
                  fetchCostSuggestions(val);
                  if (errors.costCode) {
                    setErrors((prev) => ({ ...prev, costCode: false }));
                  }
                  setCostFocusedIndex(-1); // Reset
                }}
                onKeyDown={(e) => {
                  if (showCostSuggestions && costs.length > 0) {
                    if (e.key === "ArrowDown") {
                      e.preventDefault();
                      setCostFocusedIndex((prev) =>
                        prev < costs.length - 1 ? prev + 1 : 0,
                      );
                    } else if (e.key === "ArrowUp") {
                      e.preventDefault();
                      setCostFocusedIndex((prev) =>
                        prev > 0 ? prev - 1 : costs.length - 1,
                      );
                    } else if (e.key === "Enter" || e.key === "Tab") {
                      if (costFocusedIndex >= 0) {
                        e.preventDefault();
                        handleCostCodeSelect(costs[costFocusedIndex]);
                      }
                    }
                  }
                }}
                className={`w-full border rounded px-3 py-2 ${getInputBorderClass(
                  "costCode",
                )}`}
              />
              {selectedCostDescription && (
                <p className="text-sm text-gray-600 text-left mt-1">
                  {selectedCostDescription}
                </p>
              )}
              {costNotFound && (
                <p className="text-xs text-red-500 mt-1">No Cost code found</p>
              )}

              {showCostSuggestions && (
                <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[200px] overflow-y-auto custom-scrollbar text-sm w-full whitespace-nowrap">
                  {loadingCostCodes ? (
                    <div className="p-2 text-gray-500 flex w-full justify-center items-center">
                      <CircularProgress size={20} />
                    </div>
                  ) : costs.length === 0 ? (
                    <li className="px-3 flex w-full justify-center py-2 text-gray-500">
                      No results found.
                    </li>
                  ) : (
                    costs.map((code, index) => (
                      <li
                        key={index}
                        onClick={() => handleCostCodeSelect(code)}
                        onMouseEnter={() => setCostFocusedIndex(index)}
                        className={`px-2 py-1 cursor-pointer ${
                          costFocusedIndex === index
                            ? "bg-gray-200"
                            : "hover:bg-gray-100"
                        }`}
                      >
                        {code.cost_code} - {code.costcode_name}
                      </li>
                    ))
                  )}
                </ul>
              )}
            </div>
            <div className="flex gap-4">
              <div className="w-[50%] flex flex-col items-start justify-start">
                <label className="block text-sm text-left font-medium my-2">
                  Clock In Time
                </label>
                <div className="flex items-center justify-center w-full border border-[#E4E4E7] bg-white rounded-[6px]">
                  <TimePicker
                    format="hh:mm aa"
                    showMeridiem
                    value={clockInTime}
                    onChange={handleClockInTimeChange}
                    className={`w-full text-sm border rounded ${getInputBorderClass(
                      "clockInTime",
                    )}`}
                  />
                </div>
              </div>

              <div className="w-[50%] flex flex-col items-start justify-start">
                <label className="block text-sm text-left font-medium my-2">
                  Clock Out Time
                </label>
                <div className="flex items-center justify-center w-full border border-[#E4E4E7] bg-white rounded-[6px]">
                  <TimePicker
                    value={clockOutTime}
                    onChange={handleClockOutTimeChange}
                    format="hh:mm aa"
                    showMeridiem
                    //  style={{ zIndex: 1001 }} // Add a high z-index here
                    className={`w-full text-sm border rounded ${getInputBorderClass(
                      "clockOutTime",
                    )}`}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="w-full">
            <div>
              <label className="block text-sm text-left font-medium">
                Break Time (Minutes)
              </label>
              <input
                type="number"
                value={breakTime}
                onChange={(e) => {
                  if (errors.breakTime) {
                    setErrors((prev) => ({ ...prev, breakTime: false }));
                  }
                  setBreakTime(e.target.value);
                }}
                className={`w-full border rounded px-3 py-2 ${getInputBorderClass(
                  "breakTime",
                )}`}
                min="0"
              />
            </div>

            <div className="w-full flex gap-4">
              <div className="w-1/2">
                <label className="block text-sm text-left font-medium">
                  Per Diem ($)
                </label>
                <input
                  type="text"
                  value={perDiem}
                  onChange={(e) => {
                    if (errors.perDiem) {
                      setErrors((prev) => ({ ...prev, perDiem: false }));
                    }
                    setPerDiem(e.target.value);
                  }}
                  className={`w-full border rounded px-3 py-2 ${getInputBorderClass(
                    "perDiem",
                  )}`}
                  min="0"
                />
              </div>
              <div className="w-1/2 ">
                <label className="block text-sm text-left font-medium mb-1">
                  Select Date
                </label>
                <DatePicker
                  selected={selectdate}
                  onChange={handleDtChange}
                  className="w-full border rounded px-3 py-2" // Input field
                  wrapperClassName="w-full" // Outer wrapper
                  dateFormat="MM-dd-yyyy"
                />
              </div>
            </div>
          </div>

          <div className="mt-4 flex justify-end w-full">
            <button
              type="submit"
              // disabled={!isFormValid()}
              className={`px-6 py-2  text-white rounded-lg ${
                !isFormValid() ? "bg-[#944f4f]" : "bg-[#8B1D1D]"
              }`}
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmpModal;
